import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

//components
import { SbRespRefineMenuStoneCutSelect } from '../SbRespRefineMenuStoneCutSelect/SbRespRefineMenuStoneCutSelect';
import { SbSharedRefineMenuExpandableItemList } from '../../SbSharedRefineMenu/SbSharedRefineMenuExpandableItemList/SbSharedRefineMenuExpandableItemList';

export const SbRespRefineMenuFilterStoneCutComponent = props => {
    const { values, filterName, itemSearch, isClient } = props;

    const [stoneCutMap, setStoneCutMap] = useState({});
    const [loadStoneCutMapInitialized, setLoadStoneCutMapInitialized] = useState(false);

    useEffect(() => {
        if (isClient && !loadStoneCutMapInitialized) {
            setLoadStoneCutMapInitialized(true);
            import(
                /* webpackChunkName: "sbRespRefineMenuStoneCutComponentMap" */
                './sbRespRefineMenuStoneCutComponentMap'
            ).then(moduleExport => {
                setStoneCutMap(moduleExport.stoneCutMap);
            });
        }
    }, [isClient, loadStoneCutMapInitialized]);

    return (
        <SbSharedRefineMenuExpandableItemList
            filterName={filterName}
            availableFilterValues={values}
        >
            {({ valuesToShow }) => (
                <SbRespRefineMenuStoneCutSelect
                    filterName={filterName}
                    itemSearch={itemSearch}
                    valuesToShow={valuesToShow}
                    stoneCutMap={stoneCutMap}
                />
            )}
        </SbSharedRefineMenuExpandableItemList>
    );
};

SbRespRefineMenuFilterStoneCutComponent.propTypes = {
    isClient: PropTypes.bool,
    values: PropTypes.array.isRequired,
    filterName: PropTypes.string.isRequired,
    itemSearch: PropTypes.object.isRequired,
};

export const SbRespRefineMenuFilterStoneCut = createFragmentContainer(
    SbRespRefineMenuFilterStoneCutComponent,
    {
        itemSearch: graphql`
            fragment SbRespRefineMenuFilterStoneCut_itemSearch on ItemSearchQueryConnection {
                ...SbRespRefineMenuStoneCutSelect_itemSearch
                appliedFilters {
                    name
                    localizedFilterName
                    canBeDismissed
                    clearAllLinkReference
                    values {
                        urlLabel
                        linkReference
                        count
                        displayName
                    }
                }
            }
        `,
    }
);
